import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router';
import { Helmet } from 'react-helmet-async';
import appConfig from '../configs/appConfig';

import { checkUserHaveAccount, signUpUser } from '../actions/app';
import SignUpForm from '../forms/SignUpForm';
import ErrorMessage from '../components/ErrorMessage';
import SignUpFormFirstStep from '../forms/SignUpFormFirstStep';


const SignUp = ({ signUpUser, checkUserHaveAccount }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // The step lives in the URL (?step=2), as before.
  const step = +searchParams.get('step') || 1;
  const email = searchParams.get('email');
  const team = searchParams.get('team');
  const initialValues = {
    email,
  };
  const appSiteUrl = appConfig.APP_SITE_URL;

  const handleSubmit = (values) => {
    const {
      firstName: first_name,
      lastName: last_name,
      email: userEmail,
      password,
    } = values;
    if (step === 1) {
      checkUserHaveAccount({ email: userEmail });
    } else {
      signUpUser(first_name, last_name, userEmail, password);
    }
  };

  return (
    <div className="full-height-wrap section-grey">
      <Helmet>
        <title>Регистрация | Jobs Widget</title>
      </Helmet>
      <h2 className="auth-title">Регистрация соискателя</h2>
      <div className="auth-content">
        {team && (
          <div>
            <h2 className="auth-title ">
              Вас пригласили в команду
              {' '}
              {team}
            </h2>
            <div className="auth-text">Зарегистрируйтесь в сервисе, чтобы принять приглашение</div>
          </div>
        )}
        {step === 1 && (
          <>
            <SignUpFormFirstStep
              onSubmit={handleSubmit}
              initialValues={initialValues}
            />
            <ErrorMessage errorName="userHaveAccountFail" />
          </>
        )}
        {step === 2 && (
          <SignUpForm
            onSubmit={handleSubmit}
            initialValues={initialValues}
          />
        )}
        <hr />
        <div>
          <h3 className="text-center">Вход</h3>
          <div className="signUp-type-change-wrapper mt-4">
            <Link to="/login" className="button signUp-type-change">Соискателя</Link>
            <button
              onClick={() => window.location.assign(`${appSiteUrl}/login`)}
              type="button"
              className="button signUp-type-change"
            >
              Работодателя
            </button>
          </div>
        </div>
        <div className="auth-license-text">
          Нажимая кнопку зарегистрироваться вы принимаете
          {' '}
          <Link to="/contest-to-personal-data-processing">соглашение на обработку персональных данных</Link>
        </div>
        <br />
        <ErrorMessage errorName="registerUserError" />
      </div>
    </div>
  );
};

SignUp.propTypes = {
  signUpUser: PropTypes.func.isRequired,
  checkUserHaveAccount: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  signUpUser: (first_name, last_name, email, password) => dispatch(signUpUser(first_name, last_name, email, password)),
  checkUserHaveAccount: values => dispatch(checkUserHaveAccount(values)),
});

export default connect(null, mapDispatchToProps)(SignUp);
